import importer from 'common/importer'

const getWirecardInfo = importer('Sagas/Wirecard/getWirecardInfo/main')
const getWirecardInfoSuccess = importer('Sagas/Wirecard/getWirecardInfo/success')
const getWirecardInfoFailure = importer('Sagas/Wirecard/getWirecardInfo/failure')

export default {
  getWirecardInfo,
  getWirecardInfoSuccess,
  getWirecardInfoFailure
}
